/**
 * 处理添加购物车操作
 */
if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();
                this.form = this.querySelector('form');
                if(!this.form) return;

                this.isloading = false;
                this.error = false;
                this.variantIdInput.disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this)); // 添加提交购物车监听

                this.addCartButtons = this.querySelectorAll('button[type="submit"]'); // 添加购物车按钮，可能有多处按钮

                this.cartDrawer = document.getElementById('Cart-Drawer');
                if (this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) this.addCartButtons.forEach(button=>{
                    button.setAttribute('aria-haspopup', 'dialog');
                    button.setAttribute('aria-expanded', 'false');
                    button.setAttribute('aria-controls', 'Cart-Drawer');
                });

                this.errorMessageWrapper = document.getElementById(`Product-Form-Error-Message-${this.dataset.section}`);
                // 快速购物弹窗
                this.quickAddDrawer = this.closest('product-side-drawer');

                // 迷你结账
                this.miniChecker = document.getElementById(`Product-Mini-Checkout-${this.dataset.section}`);
                if(this.miniChecker) {
                    this.miniCheckerObserver = new IntersectionObserver((entries, observer)=>{
                        if(entries[0].isIntersecting) {
                            this.hideMiniCheck();
                        } else if (entries[0].boundingClientRect.top < 0){
                            this.showMiniCheck();
                        }
                    }, {
                        root: null,
                        rootMargin: '-200px 0px 0px 0px'
                    });

                    this.miniCheckerObserver.observe(this);
                }
            }

            disconnectedCallback() {
                if(this.miniCheckerObserver) this.miniCheckerObserver.disconnect();
            }

            get variantIdInput() {
                return this.form.querySelector('[name=id]');
            }
            
            /**
             * 是否隐藏错误信息
             * 当产品是礼品卡的时候，隐藏错误信息
             * @returns {boolean}
             */
            get hideErrors() {
                return this.dataset.hideErrors === 'true';
            }

            /**
             * 处理点击提交购物车
             * @param event
             */
            onSubmitHandler(event) {
                if(this.isloading) return;
                event.preventDefault();

                if(Array.from(this.addCartButtons).find(button => button.hasAttribute('disabled'))) return;

                this.handleErrorMessage();
                this.startLoading();

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];  /* 浏览器会自动为 formData 对象生成带有边界(boundary)的 multipart/form-data 类型*/

                const formData = new FormData(this.form);
                console.log('🛒 Product-form submitting with variant ID:', formData.get('id'));
                console.log('📦 All form data entries:');
                for(let pair of formData.entries()) {
                    console.log('  ' + pair[0] + ':', pair[1]);
                }
                
                formData.append('sections', this.getSectionsToRender().map((section)=>section.section).join());
                formData.append('sections_url', window.location.pathname);
                config.body = formData;

                fetch(`${window['routes']['cart_add_url']}`, config)
                    .then((response) => {
                        console.log('📬 Cart add response status:', response.status);
                        return response.json();
                    })
                    .then((response) => {
                        console.log('📬 Cart add response:', response);
                        if (response.status) {
                            console.log('❌ Cart add FAILED:', response.description, response.errors);
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);
                            return this.error = true;
                        }
                        console.log('✅ Cart add SUCCESS');
                        this.error = false;

                        // Dynamic UI updates should never block add-to-cart success.
                        // If any UI update throws, we still want to open the cart drawer.
                        try {
                            // 动态更新Sections内容
                            console.log('🔄 Updating sections...', this.getSectionsToRender());
                            console.log('📦 Response sections:', response['sections']);
                            if (window.SectionDynamicUpdate) {
                                SectionDynamicUpdate.updateSections(this.getSectionsToRender(), response['sections']);
                                console.log('✅ Section update complete');
                            } else {
                                console.warn('⚠️ SectionDynamicUpdate not found, updating manually');
                                // Manually update sections
                                this.getSectionsToRender().forEach(function(section) {
                                    const sectionKey = Object.keys(response['sections']).find(key => key.includes(section.section));
                                    if (sectionKey && response['sections'][sectionKey]) {
                                        console.log('🔧 Updating section:', section.id, 'with key:', sectionKey);
                                        const parser = new DOMParser();
                                        const doc = parser.parseFromString(response['sections'][sectionKey], 'text/html');

                                        // Special case: cart-icon-bubble — replace all .cart-count-bubble on the page.
                                        // The header uses #Cart-Icon-Bubble / .cart-count-bubble, not a standalone
                                        // cart-icon-bubble section, so .shopify-section would target the wrong element.
                                        if (section.section === 'cart-icon-bubble') {
                                            const sectionEl = doc.body && doc.body.firstElementChild;
                                            const newBubbleHTML = sectionEl ? sectionEl.innerHTML : '';
                                            if (newBubbleHTML) {
                                                document.querySelectorAll('.cart-count-bubble').forEach(function(b) {
                                                    b.outerHTML = newBubbleHTML;
                                                });
                                                console.log('✅ Updated cart count (Cart-Icon-Bubble)');
                                            } else {
                                                console.warn('⚠️ Could not extract cart bubble from cart-icon-bubble section');
                                            }
                                            return;
                                        }

                                        const newContent = doc.querySelector(section.selector);
                                        const existingContent = document.querySelector(section.selector);
                                        if (newContent && existingContent) {
                                            existingContent.innerHTML = newContent.innerHTML;
                                            console.log('✅ Updated', section.id);
                                        } else {
                                            console.warn('⚠️ Could not find selector', section.selector, 'for section', section.id);
                                        }
                                    }
                                });
                            }

                            if (typeof publish === 'function') {
                                console.log('📢 Publishing cartUpdate event');
                                publish(PUB_SUB_EVENTS.cartUpdate, {
                                    source: 'product-form',
                                    productVariantId: formData.get('id'),
                                    cartData: response,
                                });
                            } else {
                                console.warn('⚠️ publish function not found');
                            }
                        } catch (e) {
                            // Log but do NOT treat as add-to-cart failure
                            console.warn('product-form: post-add UI update failed (non-fatal)', e);
                        }

                        try {
                            if(this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) {
                                // 打开抽屉
                                this.cartDrawer.show(event.submitter);
                            } else {
                                return window.location = window['routes']['cart_url'];
                            }
                        } catch (e) {
                            console.warn('product-form: failed to open cart drawer (non-fatal)', e);
                            // Fallback: try clicking any cart toggle
                            const cartToggle = document.querySelector('[aria-controls="Cart-Drawer"]');
                            if (cartToggle) cartToggle.click();
                        }
                    })
                    .catch((e) => {
                        this.handleErrorMessage(window['variantStrings']['unknownError']);
                        this.error = true;
                    })
                    .finally(()=>{
                        this.endLoading();
                        // 关闭迷你结账
                        this.hideMiniCheck();
                    });
            }

            /**
             * 获取需要重新渲染的位置
             * @returns {[{section: string, selector: string, id: string}]}
             */
            getSectionsToRender() {
                const sections = [
                    {
                        id: 'Cart-Icon-Bubble',
                        section: 'cart-icon-bubble',
                        selector: '.shopify-section'
                    }
                ];

                if(this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) {
                    sections.push({
                        id: 'Cart-Drawer',
                        section: this.cartDrawer.dataset.section,
                        selector: '#Cart-Drawer-Details',
                    });
                }

                return sections;
            }

            /**
             * 错误显示
             * @param errorMessage
             */
            handleErrorMessage(errorMessage = null) {
                if (this.hideErrors || !this.errorMessageWrapper) return;

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
                this.errorMessageWrapper.textContent = errorMessage ? errorMessage : '';
            }

            startLoading() {
                this.isloading = true;

                this.addCartButtons.forEach(button => {
                    button.setAttribute('disabled', 'disabled');
                    button.classList.add('loading');
                });
            }

            endLoading() {
                this.isloading = false;

                this.addCartButtons.forEach(button => {
                    button.removeAttribute('disabled');
                    button.classList.remove('loading');
                });

                // 关闭快速预览
                if(!this.error && this.quickAddDrawer) {
                    this.quickAddDrawer.hide();
                }
            }

            showMiniCheck() {
                if(this.miniChecker) this.miniChecker.classList.add('active');
            }

            hideMiniCheck() {
                if(this.miniChecker) this.miniChecker.classList.remove('active');
            }
        }
    );
}
